import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../../services/admin/auth.service';
import { ToastrService } from 'ngx-toastr';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
    const authService = inject(AuthService);
    const toastr = inject(ToastrService);
    const token = authService.getToken();

    const currentOrg = authService.getCurrentOrg();

    // Prepare headers
    const headers: any = {};
    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }
    if (currentOrg && currentOrg.id) {
        headers['X-Organization-ID'] = currentOrg.id.toString();
    }

    if (Object.keys(headers).length > 0) {
        req = req.clone({ setHeaders: headers });
    }

    return next(req).pipe(
        catchError((error: HttpErrorResponse) => {
            // Check if the error is due to session expiration / unauthenticated
            if (error.status === 401 || error.status === 403) {
                // Determine if we need to show the toast based on current URL to avoid spamming
                const currentUrl = window.location.href;
                if (!currentUrl.includes('/auth/login')) {
                    toastr.error('Your session has expired. Please login again.', 'Session Expired');
                    authService.logout();
                }
            }
            return throwError(() => error);
        })
    );
};
